import { isClientSide } from "@helper/utils";
import { useEffect, useState } from "react";

type NavigatorWithMS = Navigator & {
  msMaxTouchPoints?: number;
};

const MOBILE_BREAKPOINT = 768;

export function useDeviceType() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const nav = navigator as NavigatorWithMS;

    const hasTouch =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      (nav.msMaxTouchPoints ?? 0) > 0;

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsTouch(hasTouch);
    document.documentElement.setAttribute("is_touch_device", String(hasTouch));
  }, []);

  return isTouch;
}

export function useMobileResponsive(forceMobile?: boolean) {
  const [mounted, setMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    isClientSide
      ? (forceMobile ?? window.innerWidth <= MOBILE_BREAKPOINT)
      : false,
  );

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
    const handleResize = () => {
      setIsMobile(forceMobile ?? window.innerWidth <= MOBILE_BREAKPOINT);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [forceMobile]);

  return { isMobile, mounted };
}
